// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Y4i_","list":"BalanceDue_list__1_MuU","listRow":"BalanceDue_listRow__2kIw0","total":"BalanceDue_total__2nXKH"};